export default __webpack_public_path__ + "media/images/react_icons/building-8f8141ecf3978d3721b615452ce76a66.svg";